module.exports = __webpack_public_path__ + "static/media/image3.ed5d3ec1.jpg";